<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="8">
        <CaseDetailsFullScreen
          :searchCase="caseReport.searchCase"
          :sources="caseReport.criteria.sources"
          :elevation="0"
        />
      </v-col>
      <v-spacer />
      <v-col cols="2" class="ma-4">
        <!-- Assignee -->
        <v-row dense>
          <v-col>
            <v-select
              class="caption"
              dense
              label="Assignee"
              prepend-icon="mdi-account"
              v-model="caseReport.assignedToUserName"
              :items="getUsersWithUnassigned"
              :item-text="
                (item) => {
                  return getTextForUserSelect(item);
                }
              "
              item-value="email"
              @change="setAssignee"
              :loading="assigneeLoading"
            />
          </v-col>
        </v-row>

        <!-- Status -->
        <v-row dense>
          <v-col>
            <v-select
              class="caption"
              dense
              label="Status"
              prepend-icon="mdi-check-all"
              v-model="caseReport.status"
              :items="reportStatusesSelect"
              item-text="title"
              item-value="code"
              @change="setStatus"
              :loading="statusLoading"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Matches table -->

    <v-row no-gutters>
      <v-col>
        <ResultsTable
          :results="caseReport.matches"
          tableClass="elevation-2 mt-10"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <CaseReportComments
          :comments="caseReport.comments"
          :caseReportId="caseReport.id"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CaseDetailsFullScreen from "../components/CaseDetailsFullScreen";
import ResultsTable from "../components/ResultsTable";
import { formatDateTime } from "../utils/dateUtils";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import axios from "axios";
import { reportStatusesSelect } from "../utils/reportStatuses";
import { getTextForUserSelect } from "../utils/userUtils";
import CaseReportComments from "../components/CaseReportComments.vue";

export default {
  name: "CaseReportBody",
  components: {
    CaseDetailsFullScreen,
    ResultsTable,
    CaseReportComments,
  },
  data() {
    return {
      reportStatusesSelect,
      isAddModalVisible: false,
      isLimitedEditModalVisible: false,
      statusLoading: false,
      assigneeLoading: false,
      selectedCase: null,
      caseRecord: null,
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  props: {
    caseReport: {},
  },
  computed: {
    ...mapGetters(["getCaseGroups", "users"]),
    getUsersWithUnassigned: function () {
      var users = [...this.users];
      users.push({ email: null, name: "Unassigned" });
      return users;
    },
  },
  methods: {
    ...mapActions([
      "setGlobalAlert",
      "resolveCaseReports",
      "assignCaseReports",
    ]),
    getTextForUserSelect,
    formatDateTime,
    setAssignee(assignedToUserName) {
      this.assigneeLoading = true;
      this.assignCaseReports({
        caseReportIds: [this.caseReport.id],
        assignedToUserName: assignedToUserName,
        comment: null,
      })
        .catch(() => {
          this.setGlobalAlert({
            alert: true,
            color: "red",
            alertTitle: "Oops.",
            alertMessage: this.$t("error.general.unhandled"),
          });
        })
        .finally(() => {
          this.assigneeLoading = false;
        });
    },
    setStatus(code) {
      this.statusLoading = true;
      // Resolution table will refresh, clearing this report if the status was changed from unresolved.
      axios
        .post("/api/caseReport/status", {
          caseReportIds: [this.caseReport.id],
          status: code,
        })
        .catch(() => {
          this.setGlobalAlert({
            alert: true,
            color: "red",
            alertTitle: "Oops.",
            alertMessage: "Unable to update status, please try again.",
          });
        })
        .finally(() => {
          this.statusLoading = false;
        });
    },
  },
  created: function () {},
};
</script>